var AccessPermissions;
(function(AccessPermissions) {
    /**
     * Restricted permission unauthorized regardless.
     */ AccessPermissions["restricted"] = "restricted";
    /**
     * Public permission grants authorization regardless of whether the user is authenticated or not.
     */ AccessPermissions["public"] = "public";
    /**
     * PublicOnly permission grants authorization only when the user is not authenticated.
     */ AccessPermissions["publicOnly"] = "publicOnly";
    /**
     * Protected permission grants authorization only when the user is authenticated.
     */ AccessPermissions["protected"] = "protected";
    /**
     * Protected permission grants authorization only when the user is authenticated and has empty roles.
     */ AccessPermissions["protectedNoRoles"] = "protectedNoRoles";
})(AccessPermissions || (AccessPermissions = {}));
/**
 * Reasons why a permission check may fail
 * These apply to both server and client side checks.
 */ var UnauthorizedReason;
(function(UnauthorizedReason) {
    /**
     * Indicates the user is not authenticated but
     * authentication is required for the action in question.
     */ UnauthorizedReason["NotAuthenticated"] = "notAuthenticated";
    /**
     * Indicates the user is authenticated, but the action in question
     * requires not to be authenticated.
     */ UnauthorizedReason["IsAuthenticated"] = "isAuthenticated";
    /**
     * Indicates the user HAS roles when they should not. This error occurs
     * when a signed-in user WITH roles attempts to access the KYC page.
     */ UnauthorizedReason["HasRoles"] = "hasRoles";
    /**
     * Indicates that the user does not have the roles required
     * for the action in question.
     */ UnauthorizedReason["MissingRoles"] = "missingRoles";
    /**
     * Indicate the no permissions were passed to check.
     */ UnauthorizedReason["MissingPermissions"] = "missingPermissions";
    /**
     * Unexpectedly, will occur if when we didn't cover a use case.
     */ UnauthorizedReason["Unexpected"] = "unexpected";
    /**
     * Indicate an area when no access regardless of authentication or roles.
     */ UnauthorizedReason["Restricted"] = "restricted";
})(UnauthorizedReason || (UnauthorizedReason = {}));

export { AccessPermissions, UnauthorizedReason };
//# sourceMappingURL=types.js.map
